import { RewardRaw } from '~/shared';

export interface IQuestPromocodeProps {
	name: string;
	code: string;
	description: string;
	currentCount?: number;
	targetCount?: number;
	currentTime?: number;
	targetTime?: number;
	complete?: boolean;
	rewards: RewardRaw[];
}

export const spanMap: Record<number, { rowSpan: number; colSpan: number }[]> = {
	1: [
		{
			rowSpan: 2,
			colSpan: 2,
		},
	],
	2: [
		{
			rowSpan: 2,
			colSpan: 1,
		},
		{
			rowSpan: 2,
			colSpan: 1,
		},
	],
	3: [
		{
			rowSpan: 2,
			colSpan: 1,
		},
		{
			rowSpan: 1,
			colSpan: 1,
		},
		{
			rowSpan: 1,
			colSpan: 1,
		},
	],
	4: [
		{
			rowSpan: 1,
			colSpan: 1,
		},
		{
			rowSpan: 1,
			colSpan: 1,
		},
		{
			rowSpan: 1,
			colSpan: 1,
		},
		{
			rowSpan: 1,
			colSpan: 1,
		},
	],
};
